import * as React from "react";
import CountryCrncy from "../../screens/Settings/CountryCrncy/CountryCrncy";
import { connect } from "react-redux";
import {
  fetchCountryList,
  fetchCurrencyList,
  fetchCountryById,
  AddCntryCrncy,
  fetchCntryCrnvy,
  DeleteCrntryCrncy,
  cntryCrncySelectedPage,
  EditCntryCurency,
} from "./action";
class CountryCrncyContainer extends React.Component<Props, State> {
  render() {
    return (
      <CountryCrncy
        //  CountrysList={this.props.CountrysList}
        fetchCountryList={this.props.fetchCountryList}
        CountrysList={this.props.CountrysList}
        fetchCurrencyList={this.props.fetchCurrencyList}
        CurrencyList={this.props.CurrencyList}
        AddCntryCrncy={this.props.AddCntryCrncy}
        fetchCntryCrnvy={this.props.fetchCntryCrnvy}
        cntrycrncyList={this.props.cntrycrncyList}
        DeleteCrntryCrncy={this.props.DeleteCrntryCrncy}
        cntrycrncyListCount={this.props.cntrycrncyListCount}
        cntryCrncySelectedPage={this.props.cntryCrncySelectedPage}
        EditCntryCurency={this.props.EditCntryCurency}
      />
    );
  }
}

function bindAction(dispatch) {
 
  return {
    fetchCountryList: () => {
      dispatch(fetchCountryList());
    },
    fetchCurrencyList: () => {
      dispatch(fetchCurrencyList());
    },
    fetchCountryById: (value) => {
    
      dispatch(fetchCountryById(value));
    },

    AddCntryCrncy: (value) => {
      dispatch(AddCntryCrncy(value));
    },

    fetchCntryCrnvy: () => {
      dispatch(fetchCntryCrnvy());
    },

    DeleteCrntryCrncy: (value) => {
    
      dispatch(DeleteCrntryCrncy(value));
    },

    cntryCrncySelectedPage: (value) => {
      dispatch(cntryCrncySelectedPage(value));
    },
    EditCntryCurency: (value) => {
  
      dispatch(EditCntryCurency(value));
    },
  };
}

function mapStateToProps(state) {
  return {
    CountrysList: state.CountryCrncyReducer.CountrysList,
    CurrencyList: state.CountryCrncyReducer.CurrencyList,
    cntrycrncyList: state.CountryCrncyReducer.cntrycrncyList,
    cntrycrncyListCount: state.CountryCrncyReducer.cntrycrncyListCount,
  };
}

export default connect(mapStateToProps, bindAction)(CountryCrncyContainer);
